import aes from 'aes-js';

export default {
  getKeyFromPass(pass) {
    return pass.repeat(32).split('').reverse().slice(-32)
      .reverse()
      .join('');
  },

  encrypt(data, password) {
    try {
      const key = this.getKeyFromPass(password).split('').map(v => v.charCodeAt(0));
      const aesCtr = new aes.ModeOfOperation.ctr(key, new aes.Counter(password.length));
      const dataBytes = aes.utils.utf8.toBytes(data);
      const encrypted = aesCtr.encrypt(dataBytes);

      return aes.utils.hex.fromBytes(encrypted);
    } catch (e) {
      console.log('Encrypt error', data, password);
      throw e;
    }
  },

  decrypt(hex, password) {
    let text = '{}';
    console.log('Decrypting', hex, password, this.getKeyFromPass(password));
    try {
      const bytes = aes.utils.hex.toBytes(hex);
      const key = this.getKeyFromPass(password).split('').map(v => v.charCodeAt(0));
      const aesCtr = new aes.ModeOfOperation.ctr(key, new aes.Counter(password.length));
      const decrypted = aesCtr.decrypt(bytes);
      text = aes.utils.utf8.fromBytes(decrypted) || '{}';
    } catch (e) {
      console.log('Decrypt error', hex, password, this.getKeyFromPass(password));
      throw e;
    }
    return text;
  },
};
